import { render, staticRenderFns } from "./ProjectStartedSuccessfully.vue?vue&type=template&id=490c572d&scoped=true"
import script from "./ProjectStartedSuccessfully.vue?vue&type=script&lang=js"
export * from "./ProjectStartedSuccessfully.vue?vue&type=script&lang=js"
import style0 from "./ProjectStartedSuccessfully.vue?vue&type=style&index=0&id=490c572d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c572d",
  null
  
)

export default component.exports